import React from 'react'
import styled from 'styled-components';

import { flagred } from '../theme/Colors';

const StyledButton = styled.a`
  border: 2px solid ${flagred};
  color: ${flagred};
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  text-decoration: none;
  text-align: center;
  padding: 5px;
  font-family: 'Open Sans';
  font-weight: 600;

  :hover {
    background-color: ${flagred};
    color: white;
  }
`;

export default StyledButton;
